export default __webpack_public_path__ + "static/media/view_eye_show.1c9fd3b3.svg";